import {buildDescriptorControl} from "../descriptorcontrols/ControlResolver";

export default (props) => buildDescriptorControl("ChoiceField", "checkbox", props);



// WEBPACK FOOTER //
// ./app/lib/common/controls/Checkbox.js